export const blogPath = (lang) => (lang === "fr" ? "/blog/" : "/" + lang + "/blog/");

export const quotePath = (lang) => (lang === "fr" ? "" : "/" + lang) + "/devis-reservation-vtc/";

// Each article carries every language; keep the root fields (_id, category, trip...) next to the translation.
export const pickTranslation = (article, lang) => {
  const translation = article.translations.find((t) => t.lang === lang);
  if (!translation) return null;
  const { translations, ...root } = article;
  return { ...root, ...translation, translations };
};

// French puts a space before : ; ? ! and inside « » — make it non-breaking so a sign never starts a line.
export const frenchSpacing = (text, lang) =>
  lang === "fr" && text ? text.replace(/ ([:;?!»])/g, "\u00a0$1").replace(/« /g, "«\u00a0") : text;

export const formatDate = (iso, lang) =>
  new Intl.DateTimeFormat(lang, { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" })
    .format(new Date(iso));

export const readingMinutes = (html = "") => {
  const words = html.replace(/<[^>]+>/g, " ").trim().split(/\s+/).length;
  return Math.max(1, Math.round(words / 220));
};

export const formatDuration = (minutes, lang) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const units = { fr: ["h", "min"], en: ["h", "min"], ru: ["ч", "мин"] }[lang] || ["h", "min"];
  if (!h) return `${m} ${units[1]}`;
  return m ? `${h} ${units[0]} ${String(m).padStart(2, "0")}` : `${h} ${units[0]}`;
};

// Rebuilds any of our Cloudinary URL formats with a new transformation, e.g. "c_fill,g_auto,ar_3:2,w_800".
export const cloudinary = (url, transformation) => {
  const match = (url || "").match(/^(https:\/\/res\.cloudinary\.com\/[^/]+)\/(?:image\/upload\/)?(?:.*?\/)?(v\d+\/.+)$/);
  if (!match) return url;
  return `${match[1]}/image/upload/${transformation},q_auto,f_auto/${match[2]}`;
};

export const cloudinarySrcSet = (url, transformation, widths) =>
  widths.map((w) => `${cloudinary(url, `${transformation},w_${w}`)} ${w}w`).join(", ");
